import { createApi } from "@secretaa/sdk";

// Một client cho cả app: gọi BFF cùng origin (`/bff/v1`), cookie HttpOnly đi kèm, CSRF đọc từ cookie.
export const api = createApi();
